// extracted by mini-css-extract-plugin
export default {"input":"Input_input__NXBhJ","readOnly":"Input_readOnly__6SsLu"};